/**
 * form-grid-item.js
 */

import React from 'react';
import { useMediaQuery, Grid } from '@mui/material';


export default function FormGridItem(props) {
  const {
    smm,
    smd,
    ...rest
  } = props;
  const xsDown = useMediaQuery(theme => 
    theme.breakpoints.down('sm'), 
    { noSsr: true });
  const betweenCustom = useMediaQuery(theme => 
    theme.breakpoints.between('sm_md', 'md'), 
    { noSsr: true });
  const isContainerMobileWidth = xsDown || betweenCustom;

  
  
  let newProps = {
    xs: 12,
    sm: isContainerMobileWidth ? 12 : 6,
    md: 6,
    lg: 6,
    xl: 4,
    ...rest
  };

  if (smm && !isContainerMobileWidth) {
    newProps.sm = smm;
  } else if (smd && isContainerMobileWidth) {
    newProps.sm = smd
  }

  return (
    <Grid item {...newProps} />
  );
}